import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export class Request {
    public static instance: Request;

    public static getInstance() {
        if (!Request.instance) {
            Request.instance = new Request();
        }
        return Request.instance;
    }

    public async get<T = any, R = AxiosResponse<T>, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<R> {
        try {
            const { data } = await axios.get<T>(url, config);
            return { data } as unknown as R;
        } catch (e) {
            return {
                data: {
                    retcode: -1,
                    msg: e.toString(),
                },
            } as unknown as R;
        }
    }

    public async post<T = any, R = AxiosResponse<T>, D = any>(
        url: string,
        data?: D,
        config?: AxiosRequestConfig<D>,
    ): Promise<R> {
        try {
            const { data: responseData } = await axios.post<T>(url, data, config);
            return { data: responseData } as unknown as R;
        } catch (e) {
            return {
                data: {
                    retcode: -1,
                    msg: e.toString(),
                },
            } as unknown as R;
        }
    }

    public async fetch(input: RequestInfo | URL, init?: RequestInit) {
        return fetch(input, init);
    }
}
